import {CurrentSale} from "../../../../../store/api/interface/demo";
import {useEffect, useState} from "react";
import {Box, Button, DialogActions} from "@mui/material";
import Loader from "react-js-loader";
import {theme} from "../../../../../_fri/themes/theme";
import CustomAlertDanger from "../../../../../_fri/components/CustomAlert/CustomAlertDanger";
import {getRTKErrorMessage} from "../../../../../_fri/utils/function";
import {useCancelPaymentMutation, useCheckTransactionStatusMutation} from "../../../../../store/api/service/ecommerce";
import useInformationHook from "../../../../../_fri/hooks/useInformationHook";
import {CancelPaymentRequest, Transaction} from "../../../../../store/api/interface/ecommerce";

interface IModalPaymentLoader {
    setStatus: (value: "pending" | "completed"|'rejected'|'expired') => void,
    close: () => void
    transaction: Transaction
    updateTransaction: (value: Transaction)=> void
}

export const EcommerceDashboardModalPaymentLoader = ({setStatus, close, transaction, updateTransaction}: IModalPaymentLoader) => {
    const info = useInformationHook();
    const [counter, setCounter] = useState(124);
    const [seconds, setSeconds] = useState(120);

    const [checkPayment, checkPaymentStatus] = useCheckTransactionStatusMutation();
    const [cancelPayment, cancelPaymentStatus] = useCancelPaymentMutation();

    useEffect(() => {

        counter > 0 && setTimeout(() => {

            setCounter(counter - 1);
            checkPayment({
                info: info,
                requestContent: {
                    transactionId: transaction.id
                }
            });
        }, 2000);

    }, [counter]);

    useEffect(() => {
        seconds > 0 && setTimeout(() => {
            seconds > 0 && setSeconds(seconds - 1);
        }, 1000);

        if (seconds === 0) {
            setStatus("expired");
            onClickCancel();
            return;
        }


    }, [seconds]);

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    useEffect(() => {

        if (!checkPaymentStatus.isSuccess) {
            return;
        }

        if (checkPaymentStatus.data.responseContent.transaction.status === "pending") {
            return;
        }

        if (checkPaymentStatus.data.responseContent.transaction.status === "completed" || checkPaymentStatus.data.responseContent.transaction.status === "rejected") {
            updateTransaction(checkPaymentStatus.data.responseContent.transaction);
            setStatus(checkPaymentStatus.data.responseContent.transaction.status);
            return;
        }

        if (checkPaymentStatus.data.responseContent.transaction.status === "canceled" ||
            checkPaymentStatus.data.responseContent.transaction.status === "refunded"

        ) {
            close();
            return;
        }


    }, [checkPaymentStatus.isSuccess]);

    const onClickCancel = () => {
        cancelPayment({
            info: info,
            requestContent: {
                transaction: {
                    id: transaction.id
                }
            }
        });
    };

    useEffect(() => {

        if(!cancelPaymentStatus.isSuccess){
            return;
        }

        close();

    }, [cancelPaymentStatus.isSuccess]);

    return (
        <>
            <Box sx={{marginTop: "2rem", marginBottom: "0.4rem"}}>
                <Loader type="spinner-cub" bgColor={theme.palette.grey.A700} size={100}/>
                <Box sx={{flexGrow: 1, fontSize: "1rem", justifyContent: "center", display: "flex"}}>
                    <Box sx={{textAlign: "center", color: theme.palette.common.black}}>
                        <Box>
                            Tiempo de espera:
                        </Box>
                        <Box sx={{fontWeight: theme.typography.fontWeightLight}}>
                            {minutes}:{remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds} min.
                        </Box>
                    </Box>
                </Box>
            </Box>
            <DialogActions sx={{justifyContent: "center", marginBottom: "1rem"}}>
                <Box>
                    <Box sx={{justifyContent: "center", display: "flex"}}>
                        <Button
                            sx={{
                                width: "6.5rem",
                                height: "3rem",
                                borderRadius: "0.5rem",
                            }}
                            color={"error"}
                            variant={"contained"}
                            onClick={onClickCancel}
                            disabled={cancelPaymentStatus.isLoading}
                        >
                            Cancelar
                        </Button>
                    </Box>
                </Box>

            </DialogActions>
        </>
    );
};